import { render, staticRenderFns } from "./ErtesitesLista.vue?vue&type=template&id=57cc66b8&"
import script from "./ErtesitesLista.vue?vue&type=script&lang=js&"
export * from "./ErtesitesLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports